// /products/<product-handle>.js

var search;
poll = function() {
  //search for value in location search
//   console.log("function is running")
  if (window.location.search.includes("?variant=")) {

    path = window.location.pathname + window.location.search;
    if (path != search) {
    	console.log("true");
    	search = path;
     	retrieve_quantity(path);
    }

  }
}


function retrieve_quantity(path) {
 
  
	$.ajax({
      url: path,
      success: function(data) {
      	html = $.parseHTML(data);
        quantity = $(html).find('.product-quantity').text();
        $('.product-quantity').text(quantity);
//         console.log(quantity);
      },
      error: function(error) {
      	console.log(error);
      }
	});
    

}

setInterval(poll, 50);

